import { render } from "./AssignmentSelect.vue?vue&type=template&id=a7d5c80e"
import script from "./AssignmentSelect.vue?vue&type=script&lang=js"
export * from "./AssignmentSelect.vue?vue&type=script&lang=js"

import exportComponent from "/builds/tel/jcr/ungerboeck_tables/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__